import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65aa544d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=65aa544d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa544d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65aa544d')) {
      api.createRecord('65aa544d', component.options)
    } else {
      api.reload('65aa544d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=65aa544d&scoped=true", function () {
      api.rerender('65aa544d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/points/index.vue"
export default component.exports